
// SMT参数格式化
export const formatPcbaReturnParams = (smtParams, pcbParams, otherParams = {}) => {
  const params = { ...smtParams, ...otherParams }
  const { order_info, address, invoice, ...smt_params } = params

  // 删除前端字段
  delete smt_params.pcbParams
  delete smt_params.saveLoading

  // 判断PCB和BOM是不是客供 客供提供数量
  if (smt_params.buy_bom == 2) {
    smt_params.bom_cus_material_num = smt_params.bom_material_type_number
  } else {
    smt_params.bom_cus_material_num = 0
  }
  if (smt_params.custom_pcb_ban == 3) {
    smt_params.pcb_cus_material_num = 1
  } else {
    smt_params.pcb_cus_material_num = 0
  }
 
  // 将 order_info, address, invoice 提华秋采购BOM取到与 smt_params 同级
  return {
    order_info,
    address,
    invoice,
    smt_params,
    pcb_params: smt_params.custom_pcb_ban == 1 ? { ...pcbParams, express: smt_params.express, fhp: 0 } : {}
  }
}
// 是否显示判断
export const isShowSmtParams = (params) => ([1,2].includes(params.custom_pcb_ban) && (
    (
      // FR-4
      params.pcb_board_type === 'FR-4' && 
      // 单片出货 || 连片(华秋代拼)
      [1, 2].includes(params.units)
    ) ||
    (
      // FPC
      params.pcb_board_type === 'FPC' &&
      // 单片出货
      params.units === 1
    )
  ))
// PCBA返单页下单校验
export const validatePcbaReturnParams = params => {
  console.log('params', params)
  const number_type = params.number_type
  const valids = [
    { 
      key: 'buy_bom',
      flag: !params.buy_bom, 
      tips: '请选择是否华秋采购BOM'
    },
    { 
      key: 'custom_pcb_ban',
      flag: params.order_info.return_pcb_order_sn && params.order_info.return_pcb_order_sn !== '0' && !params.custom_pcb_ban, 
      tips: '请选择是否华秋定制PCB返单'
    },
    { 
      key: 'bcount',
      flag: params.custom_pcb_ban == 1 && !params.pcb_bcount, 
      tips: '请选择PCB数量'
    },
    { 
      key: 'number',
      flag: !params.number, 
      tips: '请输入生产数量'
    },
    { 
      key: 'number',
      flag: () => params.pcsNumForSet && (+params.pcsNumForSet < +params.number)&&+number_type===0&& params.custom_pcb_ban == 1,
      tips: 'SMT的生产数量不能大于pcb数量'
    },
    { 
      key: 'solder_paste_type',
      flag: !params.solder_paste_type, 
      tips: '请选择制程要求'
    },
    { 
      key: 'is_first_confirm',
      flag: !params.is_first_confirm && params.is_first_confirm !== 0, 
      tips: '请选择样品图确认'
    },
    {
      key: 'need_conformal_coating',
      flag: params.need_conformal_coating === '',
      tips: '请选择三防漆'
    },
    {
      key: 'need_conformal_coating',
      flag: params.need_conformal_coating > 0 && !params.need_conformal_coating_remark && params.is_dodge_solder_joint == 1,
      tips: '请填写加工要求'
    },
  ]

  return valids.filter(item => {
    const flag = typeof item.flag === 'function' ? item.flag() : item.flag
    return flag
  })
}
